import React, { useState } from 'react'
import { postRequest } from '../../utility/apiRequest'
import { NavLink } from 'react-router-dom'
import { HiArrowLeft } from 'react-icons/hi'

const ForgotPassword: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [identifier, setIdentifier] = useState<string>('')
    const [response, setResponse] = useState('')
    const [userResponseType, setUserResponseType] = useState<boolean>(false)

    const handleForgotPassword = async () => {
        const normalizedIdentifier = identifier.trim()
        if (!normalizedIdentifier) return

        setLoading(true)
        const result = await postRequest('auth/forgot-password', { identifier: normalizedIdentifier })

        if (result.data.success === true) {
            setLoading(false)
            setUserResponseType(true)
            setResponse(result.data.message || 'If the account exists, a reset link has been sent.')
            setTimeout(() => {
                setResponse('')
                setIdentifier('')
            }, 5000)
            return
        }

        setLoading(false)
        setUserResponseType(false)
        setResponse(result?.data?.message || 'Encountered an error. Please try again.')
        setTimeout(() => {
            setResponse('')
        }, 5000)
    }

    const isDisabled = loading || !identifier.trim()
    const buttonLabel = loading ? 'Please wait...' : 'Continue'

    return (
        <>
            <div className="verification py-5">
                <div className="container py-5">
                    <div className="row justify-content-center align-items-center text-center py-5">
                        <div className="col-7">
                            <img src="/assets/lock.png" alt="logo" className="img-fluid mb-4" width={'60px'} />
                        </div>
                        <h3 className="signup__col--title mb-3">Forget password?</h3>
                        <p className="pb-5">Enter the email, username, or phone linked to your account</p>
                        <div className=" col-md-5 text-start">
                            <div className="mb-3">
                                {response && <p className={userResponseType ? 'alert alert-success' : 'alert alert-danger'}>{response}</p>}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="identifier" className="form-label signup__col--label">
                                    Email, Username, or Phone
                                </label>
                                <input
                                    type="text"
                                    className="form-control py-3 shadow-none signup__col--inp"
                                    id="identifier"
                                    placeholder="Enter your email, username, or phone"
                                    value={identifier}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setIdentifier(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="mb-3 py-5">
                                <button className={isDisabled ? 'w-100 signup__col--disabled' : 'w-100 signup__col--btn'} disabled={isDisabled} onClick={handleForgotPassword}>
                                    {buttonLabel}
                                </button>
                            </div>
                            <div className=" text-center">
                                <p className="signup__col--label">
                                    <NavLink to="/login" style={{ color: '#2C4A8B', textDecoration: 'none', fontWeight: '600', fontSize: '14px' }}>
                                        <HiArrowLeft className="me-1" fontSize={18} /> Back to log in
                                    </NavLink>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ForgotPassword
